import { z } from 'zod/v3';

export const SQL_WORKSHEET_MAX_STATEMENT_LENGTH = 100_000;

export const SqlWorksheetIdentifierSchema = z.string().trim().min(1).max(63);

export const ExecuteSqlWorksheetBodySchema = z.object({
  statement: z.string().trim().min(1).max(SQL_WORKSHEET_MAX_STATEMENT_LENGTH),
  database: SqlWorksheetIdentifierSchema,
});

export const GenerateSqlWorksheetBodySchema = z.object({
  prompt: z.string().trim().min(1).max(2_000),
  database: SqlWorksheetIdentifierSchema,
  currentStatement: z
    .string()
    .max(SQL_WORKSHEET_MAX_STATEMENT_LENGTH)
    .optional(),
  selection: z.string().max(SQL_WORKSHEET_MAX_STATEMENT_LENGTH).optional(),
});

export const GenerateSqlWorksheetResultSchema = z.object({
  statement: z.string().trim().min(1).max(SQL_WORKSHEET_MAX_STATEMENT_LENGTH),
});

export const SqlWorksheetColumnSchema = z.object({
  name: z.string(),
  dataTypeId: z.number().int().nonnegative(),
});

export const SqlWorksheetResultSchema = z.object({
  columns: z.array(SqlWorksheetColumnSchema),
  rows: z.array(z.array(z.string().nullable())),
  rowCount: z.number().int().nonnegative(),
  truncated: z.boolean(),
  durationMs: z.number().int().nonnegative(),
  command: z.string(),
  statementCount: z.number().int().positive(),
});

export const SqlWorksheetDatabaseSchema = z.object({
  name: z.string(),
  isDefault: z.boolean(),
});

export const SqlWorksheetDatabaseListSchema = z.object({
  databases: z.array(SqlWorksheetDatabaseSchema),
});

export const SqlWorksheetSchemaListSchema = z.object({
  schemas: z.array(z.object({ name: z.string() })),
});

export const SqlWorksheetTableKindSchema = z.enum([
  'table',
  'view',
  'materialized_view',
  'partitioned_table',
  'foreign_table',
]);

export const SqlWorksheetTableListSchema = z.object({
  tables: z.array(
    z.object({
      name: z.string(),
      kind: SqlWorksheetTableKindSchema,
    }),
  ),
});

export const SqlWorksheetColumnListSchema = z.object({
  columns: z.array(
    z.object({
      name: z.string(),
      dataType: z.string(),
      nullable: z.boolean(),
      ordinalPosition: z.number().int(),
      isPrimaryKey: z.boolean(),
    }),
  ),
});

export type ExecuteSqlWorksheetBody = z.infer<
  typeof ExecuteSqlWorksheetBodySchema
>;
export type GenerateSqlWorksheetBody = z.infer<
  typeof GenerateSqlWorksheetBodySchema
>;
export type GenerateSqlWorksheetResult = z.infer<
  typeof GenerateSqlWorksheetResultSchema
>;
export type SqlWorksheetResult = z.infer<typeof SqlWorksheetResultSchema>;
export type SqlWorksheetDatabaseList = z.infer<
  typeof SqlWorksheetDatabaseListSchema
>;
export type SqlWorksheetSchemaList = z.infer<
  typeof SqlWorksheetSchemaListSchema
>;
export type SqlWorksheetTableKind = z.infer<typeof SqlWorksheetTableKindSchema>;
export type SqlWorksheetTableList = z.infer<typeof SqlWorksheetTableListSchema>;
export type SqlWorksheetColumnList = z.infer<
  typeof SqlWorksheetColumnListSchema
>;
